<template>
    <div class="card card-dropdown">
        <div class="card-wrap">
            <div class="flex-center">
                <div class="title" @click="toggle">
                    <h2 v-html="title"></h2>
                    <div class="subtitle" v-html="subtitle"></div>
                </div>
                <div class="flex-filler"></div>
                <div class="handle" @click="toggle">
                    <span class="material-icons" v-if="!isOpen">keyboard_arrow_down</span>
                    <span class="material-icons" v-if="isOpen">keyboard_arrow_up</span>
                </div>
            </div>
            <div class="content" v-bind:class="{ hide : !isOpen }">
                <slot></slot>
            </div>
        </div>
    </div>

</template>

<script>
    module.exports = {
        created:function() {
            this.isOpen = this.open;
        },
        data:function() {
            return {
                isOpen:false
            }
        },
        props: {
            title:{type:String,default:""},
            subtitle:{type:String,default:""},
            open:{type:Boolean,default:false}
        },
        methods: {
            toggle:function() {
                this.isOpen = this.isOpen ? false : true;
            }
        },
        mounted:function() {

        }
    }
</script>
